/* eslint-disable @typescript-eslint/no-explicit-any */
import { id_establishment_default } from "config/establishment";
import { normalizeDocument } from "utils/mask";
import { OptionUseMutation } from "config/react-query";
import { useMutation } from "react-query";
import { api } from "services/api";
import reCaptcha from "services/RecaptchaService";
import { GetDocumentDebitsResponse } from "services/types";
import { GetAllDebitsRequest } from "./dto/get-debits.dto";

type GetDebitsPublicDepartmentParams = Pick<
  GetAllDebitsRequest,
  | "document"
  | "municipal_registration"
  | "property_registration_number"
  | "id_establishment"
  | "public_department"
>;

export const useGetDebitsPublicDepartment = (
  options: OptionUseMutation<GetDocumentDebitsResponse> = {}
) => {
  return useMutation("get-debits", getDebitsPublicDepartment, options);
};

async function getDebitsPublicDepartment({
  document,
  municipal_registration,
  property_registration_number,
  id_establishment,
  public_department,
}: GetDebitsPublicDepartmentParams): Promise<GetDocumentDebitsResponse> {
  const token = await reCaptcha.getRecaptchaToken();

  const response = await api.get("/partner/public-department/debits", {
    params: {
      ...(document && { document: normalizeDocument(document) }),
      ...(municipal_registration && { municipal_registration }),
      ...(property_registration_number && { property_registration_number }),
      public_department,
    },
    headers: {
      "id-establishment": id_establishment || id_establishment_default,
      "x-recaptcha-token": token,
    },
  });

  return response.data;
}
